import React, {useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import { Bar, BarChart, CartesianGrid, Legend, XAxis, YAxis, Tooltip } from 'recharts';
import { AppShell, Container, Grid, SimpleGrid, Space, Title, Text, Table, Button, Modal, RadioGroup, Radio } from '@mantine/core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faCar, faTree, faPlane, } from '@fortawesome/free-solid-svg-icons'
import NumberFormat from 'react-number-format';

import {store} from '../../redux/store';
import { getEqualValues, annualCostBar, costPerTonBar, co2EmissionBar, calcActions } from '../../redux/calcSlice';
import styles from './App.module.scss';
import Factory from '../Factory';
import {locationIcon, prizesIcon, processIcon, utilizationIcon, valueIcon, co2Icon, currencyIcon, operationIcon } from '../../utils/htmlIcons'

import orgTank from '../../assets/images/original-icon.png'
import rplTank from '../../assets/images/replacement-icon.png'
// import orgTank from '../../assets/images/original-icon.svg'
// import rplTank from '../../assets/images/replacement-icon.svg'


function App() {
  // const [instance, updateInstance] = usePDF({ document: <CreatePdf data={{...useSelector(printCalculation()),...useSelector(getEqualValues())}} />})
  // const [activeGrid, setActiveGrid] = useState('location')
  // const [downloadPdf, setDownloadPdf] = useState(false)
  // const [wizardVisibility, setWizardVisibility] = useState(true)

  useEffect( ()=> {
    store.dispatch(calcActions.runCalculations())
  },[])

  const equalValues = useSelector(getEqualValues())
  const costBarValues = useSelector(annualCostBar())
  const costPerTonBarValues = useSelector(costPerTonBar())
  const co2EmissionBarValues = useSelector(co2EmissionBar())
/*   const cellRows = useSelector( (state:RootState) => state.calc.linesParallel.value )
  const cellsInRow = useSelector( (state:RootState) => state.calc.cellsPerLine.value )
  const replacedCellsInRow = useSelector( (state:RootState) => state.calc.proposedNumCellsInLine.value )
 */
  const divider = (equalValues.trees > 10000) ?1000 :100

  const createIconSet = (value:string,  multiPlier:number, icon:any) => {
    if(!equalValues || !equalValues[value]) return 
    const numberOfIcons = Math.round(equalValues[value]/multiPlier)
    const retVal = []
    for(var i=0;i<numberOfIcons;i++) {
      retVal.push(<FontAwesomeIcon icon={icon} size="2x" style={{marginRight:'4px'}} key={i} />)
    }

    return retVal
  }

/*   useEffect( ()=>{

    if(downloadPdf && instance && !instance.loading) {
      const url:string = instance.url || ''
      // window.open(url,'_blank')
      const link = document.createElement('a')
      link.setAttribute('href', url)
      link.setAttribute('target', 'blank')
      link.setAttribute('download', 'MO_froth.pdf')
      link.click()
      window.URL.revokeObjectURL(url)
      setDownloadPdf(false)
    }

  },[downloadPdf,instance])

  const onDownloadPdf = () => {
    updateInstance()
    setDownloadPdf(true)    
  }

  const onSetPreset = (selectedSite:any) => {

    for(var i=0; i < selectedSite.length; i++) {
      store.dispatch({type:'calc/setValue', payload:{name: selectedSite[i].name, value: selectedSite[i].value }})
    }

  }
 */
  return (
    <AppShell className={styles.App} >

      <Container className={styles.container}>
        {/* <Title order={1}>Value Calculator for Froth Management solution</Title> */}
        <Title order={1}>Wert- und Nachhaltigkeitsrechner für Lokotrack® e-Power mobile Brecher und Siebe</Title>
        <Text className={styles.ingress}>
          Berechnen Sie Ihre Einsparungen bei der Nutzung von Strom als Energiequelle in mobilen Brech- und Siebanlagen.
        </Text>
      </Container>

      <Container className={styles.container}>
        <Grid gutter={'xs'}>
          <Grid.Col lg={12} md={12} >
            <div className={styles.gridItem}>
              <div className={styles.gridItemHeader}>
                <div className={styles.gridItemHeaderIcon} >
                  {operationIcon(60,60,'#000000')}
                </div>
                <div className={styles.gridItemHeaderLabel}>
                  <Title order={3} className={styles.gridItemActive}>Elektrizität vs. Diesel</Title>
                </div>
              </div>
              <SimpleGrid cols={2} >
                <div>
                  <div className={styles.dieselItem}>Diesel</div>
                  <Factory property="dieselConsumptionJaw"/>
                  <Factory property="dieselConsumptionCone" />
                  <Factory property="dieselConsumptionScreen" />
                </div>
                <div>
                  <div className={styles.ePowerItem}>Elektrizität</div>
                  <Factory property="eConsumptionJaw"/>
                  <Factory property="eConsumptionCone" />
                  <Factory property="eConsumptionScreen" />
                </div>
              </SimpleGrid>

              <SimpleGrid cols={2}>
                <div>
                  <Factory property="dieselConsumptionTotal" renderer="ResultLeft"/>
                </div>
                <div>
                  <Factory property="eConsumptionTotal" renderer="ResultWithTitle"/>
                </div>
              </SimpleGrid>

              <SimpleGrid cols={2}>
                <div>
                  <Factory property="dieselPrice"/>
                  <Factory property="dieselCostPerHour" renderer="ResultLeft"/>
                </div>
                <div>
                  <Factory property="ePrice" renderer="NumberInputRight"/>
                  <Factory property="eCostPerHour" renderer="ResultWithTitle"/>
                </div>
              </SimpleGrid>

              <SimpleGrid cols={2}>
                <div>
                  <div className={styles.spacerItem}>&nbsp;</div>
                  <Factory property="weeklyHours"/>
                </div>
                <div>
                  <div className={styles.spacerItem}>&nbsp;</div>
                  <Factory property="weeklyHours" renderer="Result"/>
                </div>
              </SimpleGrid>

              <SimpleGrid cols={2}>
                <div>
                  <Factory property="yearlyHours" renderer="ResultLeft"/>
                </div>
                <div>
                  <Factory property="yearlyHours" renderer="ResultWithTitle"/>
                </div>
              </SimpleGrid>

              <SimpleGrid cols={2}>
                <div>
                  <div className={styles.spacerItem}>&nbsp;</div>
                  <Factory property="capacity"/>
                </div>
                <div>
                  <div className={styles.spacerItem}>&nbsp;</div>
                  <Factory property="capacity" renderer="Result"/>
                </div>
              </SimpleGrid>
              <SimpleGrid cols={2}>
                <div>
                  <Factory property="capacityPerYear" renderer="ResultLeft"/>
                </div>
                <div>
                  <Factory property="capacityPerYear" renderer="ResultWithTitle"/>
                </div>
              </SimpleGrid>
            </div>
          </Grid.Col>
        </Grid>

        <Text className={styles.heading} >Ihre Ersparnisse</Text>
        <Grid gutter={'xs'} className={styles.benefits}>
          <Grid.Col md={6} sm={12} >
            <div className={styles.benefitsItem}>
              <div className={styles.benefitsIcon}>
                {currencyIcon(80,80,'#ffffff')}
              </div>
              <div className={styles.benefitsResult}>
                <Factory property="savingsTotal" renderer="Benefits"/>
              </div>
            </div>
          </Grid.Col>

          <Grid.Col md={6} sm={12} >
            <div className={styles.benefitsItem}>
              <div className={styles.benefitsIcon}>
                {co2Icon(80,80,'#ffffff')}
              </div>
              <div className={styles.benefitsResult}>
                <Factory property="savingsCO2Total" renderer="Benefits" prefix="negation"/>
              </div>
            </div>
          </Grid.Col>

        </Grid>
        <Text className={styles.heading} >Die CO{String.fromCharCode(8322)}-Reduktion entspricht</Text>
        <Grid gutter={'xs'} style={!equalValues.cars ?{display:'none'} :{}}>
{/*           <Grid.Col lg={4} md={6} sm={12} >
            <div className={styles.equalsItem}>
              <div className={styles.equalsIcon}>
                <div className={styles.equalsIconset} style={{color:'#e5097c'}}>
                  {
                    createIconSet('cars',10,faCar)
                  }
                </div>
                <div className={styles.equalsMultiplier}>x 10</div>
              </div>
              <div className={styles.equalsResult}>
                <Text className={styles.equalsResultsNumber}><NumberFormat value={equalValues.cars ?Math.round(equalValues.cars) :'-'} displayType={'text'} decimalScale={0}/></Text>
                <Text className={styles.equalsResultsLabel}>Cars removed from the streets</Text>
              </div>
            </div>
          </Grid.Col> */}
          <Grid.Col md={6} sm={12} >
            <div className={styles.equalsItem}>
              <div className={styles.equalsIcon}>
                <div className={styles.equalsIconset} style={{color:'#51d645'}}>
                  {
                    createIconSet('trees',divider,faTree)
                  }
                </div>
                <div className={styles.equalsMultiplier}>x {divider}</div>
              </div>
              <div className={styles.equalsResult}>
                <Text className={styles.equalsResultsNumber}><NumberFormat value={equalValues.trees ?Math.round(equalValues.trees) :'-'} displayType={'text'} decimalScale={0}/></Text>
                <Text className={styles.equalsResultsLabel}>GEPLANTE BÄUME</Text>
              </div>
            </div>
          </Grid.Col>
{/*           <Grid.Col lg={4} md={6} sm={12} >
            <div className={styles.equalsItem}>
              <div className={styles.equalsIcon}>
                <div className={styles.equalsIconset} style={{color:'#4e2098'}}>
                  {
                    createIconSet('planes',100,faPlane)
                  }
                </div>
                <div className={styles.equalsMultiplier}>x 100</div>
              </div>
              <div className={styles.equalsResult}>
                <Text className={styles.equalsResultsNumber}><NumberFormat value={equalValues.planes ?Math.round(equalValues.planes) :'-'} displayType={'text'} decimalScale={0}/></Text>
                <Text className={styles.equalsResultsLabel}>Air miles</Text>
              </div>
            </div>
          </Grid.Col> */}
        </Grid>
{/* 
        <Text className={styles.heading} >Summary</Text>
        <Table verticalSpacing="xs" className={styles.finalResults}>
          <thead>
            <tr className={styles.tableHeader}>
              <th></th>
              <th>Upgrade</th>
            </tr>
          </thead>
          <tbody>
            <Factory property="newRecoveryPerY" renderer="Table" decimals={0} />
            <Factory property="extraTonnesAnnual" renderer="Table" decimals={0} />
            <Factory property="powerTotalSavedAnnual" renderer="Table" decimals={0}/>
            <Factory property="co2TotalSavedAnnual" renderer="Table" decimals={0}/>
            <Factory property="co2FootPrint" renderer="Table" decimals={0}/>
            <Factory property="co2Payback" renderer="Table"/>

            <tr>
              <td colSpan={2} className={styles.tableSubHeaderCell}>
                <Text className={styles.tableSubHeader} >Blower</Text>
              </td>
            </tr>
            <Factory property="blowerPowerSavedAnnual" renderer="Table" decimals={0} />
            <Factory property="blowerCO2SavedAnnual" renderer="Table" decimals={0} />


            <tr>
              <td colSpan={2} className={styles.tableSubHeaderCell}>
                <Text className={styles.tableSubHeader} >Extra recovery</Text>
              </td>
            </tr>

            <Factory property="powerSavedAnnualMwh" renderer="Table" decimals={0} />
            <Factory property="co2SavedAnnual" renderer="Table" decimals={0}/>
          </tbody>
        </Table> */}

        <SimpleGrid cols={3} breakpoints={[{ maxWidth: 920, cols: 1 },]}>
          <div>
            <Text className={styles.heading} >Jährliche Kosten</Text>
            <BarChart width={300} height={150} data={costBarValues}>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip cursor={false} formatter={ (value:any, name:any, props:any) => [value, '€/a'] }/>
              <Bar dataKey="cost" fill="#4472C4" />
            </BarChart>
          </div>

          <div>
            <Text className={styles.heading} >Kosten/Tonne</Text>
            <BarChart width={300} height={150} data={costPerTonBarValues}>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip cursor={false} formatter={(value: any, name: any, props: any) => [value, '€/Tonne'] }/>
              <Bar dataKey="cost" fill="#4472C4" />
            </BarChart>
          </div>

          <div>
            <Text className={styles.heading} >CO{String.fromCharCode(8322)}-Emissionen</Text>
            <BarChart width={300} height={150} data={co2EmissionBarValues}>
              <XAxis dataKey="name" />
              <YAxis/>
              <Tooltip cursor={false} formatter={ (value:any, name:any, props:any) => [value, 'kg/h'] }/>
              <Bar dataKey="cost" fill="#4472C4" />
            </BarChart>
          </div>
        </SimpleGrid>

        <div className={styles.footerText}>
          {console.log(costPerTonBarValues)}
          Alle Werte und Zahlen im untenstehenden Wertrechner dienen nur zu Informationszwecken und können nicht als Garantie oder Verpflichtung gegenüber Metso Outotec angesehen werden. Währungs-
          und Marktschwankungen werden nicht in Echtzeit aktualisiert; Einsparungen sind für unsere Kunden nur als Richtwert zu sehen. Die CO{String.fromCharCode(8322)}-Einsparungen werden anhand des durchschnittlichen
          Kraftstoffverbrauchs und der jährlichen Betriebsstunden berechnet. Der in diesem Rechner verwendete CO{String.fromCharCode(8322)}-Umrechnungsfaktor beträgt 2,67 kg/l, basierend auf dem europäischen Emissionswert
          für Dieselöl: CO{String.fromCharCode(8322)}-Emissionen pro Liter verbranntem Diesel (kg). Die Kosten umfassen nicht die Betriebskosten, wie z. B. den Transport und die Verlagerung des Geräts, sowie die Kosten
          für Ersatzteile und Verschleißteile. Quellen: Europäische Kommission - Umweltschädliche Subventionen: Identifizierung und Bewertung, Eine Studie unter der Leitung von IEEP, mit
          Ecologic, IVM und Claudia Dias Soares für die Europäische Kommission, GD Umwelt, Anhang 5: Indikatoren auf untergeordneter Ebene für die Fallstudien. CO{String.fromCharCode(8322)}-Emissionen für
          Elektrizität: Europäische Umweltagentur (EEA): Europäische Ebene — Intensität der Treibhausgasemissionen bei der Stromerzeugung.
        </div>

      </Container>

    </AppShell>
  );
}

export default App;